import {Mapper} from '@s-ui/domain'

export class FromSpecsFormListToSpecsDatalistValueObjectMapper extends Mapper {
  constructor({datalistFormVOFactory, datalistItemFormVOFactory}) {
    super()
    this._datalistFormVOFactory = datalistFormVOFactory
    this._datalistItemFormVOFactory = datalistItemFormVOFactory
  }

  map({items}) {
    const datalist = items.map(item => this._datalistItemFormVOFactory({text: item.name, value: item.makeId}))
    return this._datalistFormVOFactory({datalist})
  }
}
